var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.546,
    height: 21.945,
    viewBox: "0 0 16.546 21.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6",
    transform: "translate(-36.49 -6.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48517",
    "data-name": "Group 48517",
    transform: "translate(36.49 6.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48481",
    "data-name": "Group 48481",
    transform: "translate(5.416 8.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48480",
    "data-name": "Group 48480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27525",
    "data-name": "Path 27525",
    d: "M102.1,101.982H97.166a.771.771,0,0,1,0-1.542H102.1a.771.771,0,0,1,0,1.542Z",
    transform: "translate(-96.395 -100.44)",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48483",
    "data-name": "Group 48483",
    transform: "translate(5.465 8.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48482",
    "data-name": "Group 48482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27526",
    "data-name": "Path 27526",
    d: "M102.869,100.986a.769.769,0,0,1-.722,1.04H97.211a.768.768,0,0,1-.269-.049.77.77,0,0,0,.722.5H102.6a.77.77,0,0,0,.269-1.492Z",
    transform: "translate(-96.941 -100.986)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48485",
    "data-name": "Group 48485",
    transform: "translate(3.231 1.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48484",
    "data-name": "Group 48484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27527",
    "data-name": "Path 27527",
    d: "M83.078,19.866H72.229v4.959a.9.9,0,0,0,.446.779L75.3,27.15H80L82.632,25.6a.9.9,0,0,0,.446-.779Z",
    transform: "translate(-72.229 -19.866)",
    fill: "#a54af4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48487",
    "data-name": "Group 48487",
    transform: "translate(3.593 1.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48486",
    "data-name": "Group 48486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27528",
    "data-name": "Path 27528",
    d: "M76.41,27.868a.181.181,0,0,1-.181-.181V24.794a.181.181,0,1,1,.362,0v2.893A.181.181,0,0,1,76.41,27.868Zm0-3.616a.181.181,0,0,1-.181-.181v-.024a.181.181,0,1,1,.362,0v.024A.181.181,0,0,1,76.41,24.252Z",
    transform: "translate(-76.229 -23.866)",
    fill: "#b171f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48489",
    "data-name": "Group 48489",
    transform: "translate(3.246 1.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48488",
    "data-name": "Group 48488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27529",
    "data-name": "Path 27529",
    d: "M82.322,19.866v4.055a.9.9,0,0,1-.446.779l-2.628,1.546h-4.7l-2.155-1.268a.9.9,0,0,0,.431.626l2.628,1.546h4.7L82.78,25.6a.9.9,0,0,0,.446-.779V19.866Z",
    transform: "translate(-72.392 -19.866)",
    fill: "#893add"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48491",
    "data-name": "Group 48491",
    transform: "translate(3.317 1.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48490",
    "data-name": "Group 48490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27530",
    "data-name": "Path 27530",
    d: "M83.5,19.866v4.507a.9.9,0,0,1-.446.779L80.421,26.7h-4.7l-2.535-1.491a.9.9,0,0,0,.359.4l2.628,1.546h4.7L83.5,25.6a.9.9,0,0,0,.446-.779V19.866Z",
    transform: "translate(-73.185 -19.866)",
    fill: "#6c2bc1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48493",
    "data-name": "Group 48493",
    transform: "translate(2.056 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48492",
    "data-name": "Group 48492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27531",
    "data-name": "Path 27531",
    d: "M71.83,7.828h-12a.6.6,0,0,1,0-1.2h12a.6.6,0,1,1,0,1.2Z",
    transform: "translate(-59.229 -6.632)",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48495",
    "data-name": "Group 48495",
    transform: "translate(2.151 0.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48494",
    "data-name": "Group 48494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27532",
    "data-name": "Path 27532",
    d: "M73.108,7.682a.6.6,0,0,1-.5.921h-12a.594.594,0,0,1-.322-.095.6.6,0,0,0,.5.276h12a.6.6,0,0,0,.322-1.1Z",
    transform: "translate(-60.279 -7.682)",
    fill: "#808285"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48497",
    "data-name": "Group 48497",
    transform: "translate(6.847 1.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48496",
    "data-name": "Group 48496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27533",
    "data-name": "Path 27533",
    d: "M112.229,19.866h3.616V27.15h-3.616Z",
    transform: "translate(-112.229 -19.866)",
    fill: "#f1f2f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48499",
    "data-name": "Group 48499",
    transform: "translate(6.847 8.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48498",
    "data-name": "Group 48498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27534",
    "data-name": "Path 27534",
    d: "M112.229,95.44h3.616v.452h-3.616Z",
    transform: "translate(-112.229 -95.44)",
    fill: "#e6e7e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48501",
    "data-name": "Group 48501",
    transform: "translate(3.231 9.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48500",
    "data-name": "Group 48500",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27535",
    "data-name": "Path 27535",
    d: "M83.078,122.631v-5.22a.9.9,0,0,0-.452-.783l-4.52-2.61a.9.9,0,0,0-.9,0l-4.52,2.61a.9.9,0,0,0-.452.783v5.22a.9.9,0,0,0,.452.783l4.52,2.61a.9.9,0,0,0,.9,0l4.52-2.61A.9.9,0,0,0,83.078,122.631Z",
    transform: "translate(-72.229 -113.897)",
    fill: "#ffc91d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48503",
    "data-name": "Group 48503",
    transform: "translate(3.317 12.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48502",
    "data-name": "Group 48502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27536",
    "data-name": "Path 27536",
    d: "M83.488,143.607l-.086-.05a.9.9,0,0,1,.086.38v5.22a.9.9,0,0,1-.452.783l-4.52,2.61a.9.9,0,0,1-.9,0l-4.435-2.56a.9.9,0,0,0,.366.4l4.52,2.61a.9.9,0,0,0,.9,0l4.52-2.61a.9.9,0,0,0,.452-.783v-5.22A.9.9,0,0,0,83.488,143.607Z",
    transform: "translate(-73.177 -143.557)",
    fill: "#ffa91a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48505",
    "data-name": "Group 48505",
    transform: "translate(4.483 11.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48504",
    "data-name": "Group 48504",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27537",
    "data-name": "Path 27537",
    d: "M94.42,136.452v-3.774a.9.9,0,0,0-.452-.783L90.7,130.008a.9.9,0,0,0-.9,0l-3.269,1.887a.9.9,0,0,0-.452.783v3.774a.9.9,0,0,0,.452.783l3.269,1.887a.9.9,0,0,0,.9,0l3.269-1.887A.9.9,0,0,0,94.42,136.452Z",
    transform: "translate(-86.075 -129.887)",
    fill: "#f79219"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48507",
    "data-name": "Group 48507",
    transform: "translate(4.568 13.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48506",
    "data-name": "Group 48506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27538",
    "data-name": "Path 27538",
    d: "M94.83,151.6l-.086-.05a.9.9,0,0,1,.086.38v3.774a.9.9,0,0,1-.452.783l-3.269,1.887a.9.9,0,0,1-.9,0l-3.183-1.838a.9.9,0,0,0,.366.4l3.269,1.887a.9.9,0,0,0,.9,0l3.269-1.887a.9.9,0,0,0,.452-.783v-3.774A.9.9,0,0,0,94.83,151.6Z",
    transform: "translate(-87.023 -151.551)",
    fill: "#ef7816"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48510",
    "data-name": "Group 48510",
    transform: "translate(5.971 13.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48509",
    "data-name": "Group 48509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48508",
    "data-name": "Group 48508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27539",
    "data-name": "Path 27539",
    d: "M105.392,153.118l.55,1.694h1.781a.181.181,0,0,1,.106.327l-1.441,1.047.55,1.694a.181.181,0,0,1-.278.2l-1.441-1.047-1.441,1.047a.181.181,0,0,1-.278-.2l.55-1.694-1.441-1.047a.181.181,0,0,1,.106-.327H104.5l.55-1.694A.181.181,0,0,1,105.392,153.118Z",
    transform: "translate(-102.536 -152.993)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48512",
    "data-name": "Group 48512",
    transform: "translate(0 16.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48511",
    "data-name": "Group 48511",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27540",
    "data-name": "Path 27540",
    d: "M37.549,184.976l.058.269a.734.734,0,0,0,.563.564l.269.058a.061.061,0,0,1,0,.12l-.269.058a.734.734,0,0,0-.563.563l-.058.269a.061.061,0,0,1-.12,0l-.058-.269a.734.734,0,0,0-.563-.563l-.269-.058a.061.061,0,0,1,0-.12l.269-.058a.734.734,0,0,0,.563-.564l.058-.269a.062.062,0,0,1,.12,0Z",
    transform: "translate(-36.49 -184.927)",
    fill: "#ffc91d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48514",
    "data-name": "Group 48514",
    transform: "translate(0.662 18.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48513",
    "data-name": "Group 48513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27541",
    "data-name": "Path 27541",
    d: "M45.366,215.026l.085.394a1.076,1.076,0,0,0,.826.826l.394.085a.09.09,0,0,1,0,.176l-.394.085a1.076,1.076,0,0,0-.826.826l-.085.394a.09.09,0,0,1-.176,0l-.085-.394a1.076,1.076,0,0,0-.826-.826l-.394-.085a.09.09,0,0,1,0-.176l.394-.085a1.076,1.076,0,0,0,.826-.826l.085-.394A.09.09,0,0,1,45.366,215.026Z",
    transform: "translate(-43.815 -214.954)",
    fill: "#ffc91d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48516",
    "data-name": "Group 48516",
    transform: "translate(14.008 10.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48515",
    "data-name": "Group 48515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27542",
    "data-name": "Path 27542",
    d: "M192.776,119.806l.073.342a.933.933,0,0,0,.716.716l.342.073a.078.078,0,0,1,0,.153l-.342.073a.933.933,0,0,0-.716.716l-.073.342a.078.078,0,0,1-.153,0l-.073-.342a.933.933,0,0,0-.716-.716l-.342-.073a.078.078,0,0,1,0-.153l.342-.073a.933.933,0,0,0,.716-.716l.073-.342A.078.078,0,0,1,192.776,119.806Z",
    transform: "translate(-191.431 -119.744)",
    fill: "#ffc91d"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsIcon);
export default __webpack_public_path__ + "static/media/rewards-icon.6b5a377afd642aaedb3394678208bd82.svg";
export { ForwardRef as ReactComponent };